<template>
    <div class="temp_con" v-html="html"></div>
</template>
<script>
import { setTitle, getUserInfo } from "../../../utils/bridge";
export default {
    data() {
        return {
            html: ""
        };
    },
    created() {
        let params = this.$route.query;
        const { title, type } = params;
        setTitle(decodeURI(title));
        (async function() {
            if (!params.token) {
                const { token } = await getUserInfo();
                this.token = token;
            } else {
                this.token = params.token;
            }
            this.getTemplate(type);
        }.bind(this)());
    },
    methods: {
        async getTemplate(type) {
            let params = this.$route.query;
            const { yingmi } = params;
            let url = "/h5/protocol/rryPrototol";
            if (yingmi) {
                url = "/h5/protocol/otherPrototol";
            }
            try {
                const res = await this.$request({
                    url: url,
                    data: this.$qs.stringify({
                        token: this.token,
                        protocolType: type
                    })
                });
                const data = res.data || {};
                this.html = data.protocolContent;
            } catch (error) {
                this.$toast(error);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.temp_con {
    padding: 20px 16px;
}
</style>
